export default {
  currentVersion: 'versão atual',
  selectVersion: 'Selecionar versão',
  goToCurrentVersion: 'Ir para a versão atual (v{version})',
  versionDeployed: 'Implantada em {date}'
}
